import { 
    GET_USERS_SUCCESS, GET_CATEGORY_ITEM_SUCCESS, GET_ITEMS_SUCCESS, AUDIT_CATEGORY_LIST, 
    GET_AUDIT_ITEM_LIST, ADD_AUDIT_ITEM, UPDATE_AUDIT_ITEM, DELETE_AUDIT_ITEM
} from './../actions/ActionTypes';
import InitialState from './InitialState';


const ComplianceAuditReducer = ( state = InitialState.complianceAudit, action) => {
    switch (action.type) {
        case GET_USERS_SUCCESS:
            return {
                ...state,
                userList: [...action.userList]
            }

        case GET_CATEGORY_ITEM_SUCCESS :
            const newCategoryList = action.categoryList.map( 
                category => ({...category, audit_items: [...category.audit_items]})
            );
            return {
                ...state,
                categoryList: [...newCategoryList]
            }
        
        case GET_ITEMS_SUCCESS :
            const newitemsAllotedToUser = {};
            for (const key in action.itemsList) {
                if (action.itemsList.hasOwnProperty(key)) {
                    newitemsAllotedToUser[key] = action.itemsList[key];
                }
            }
            return {
                ...state,
                itemsAllotedToUser: {...newitemsAllotedToUser}
            }

        case AUDIT_CATEGORY_LIST:
            return {
                ...state,
                categoryMasterList: action.categoryMasterList
            }
        
        case GET_AUDIT_ITEM_LIST:
            return {
                ...state,
                itemList: action.itemList
            }
        
        case ADD_AUDIT_ITEM:
            return {
                ...state,
                itemList: [...state.itemList, action.newItem]
            }
        
        case UPDATE_AUDIT_ITEM:
            const newItemList = state.itemList.map(item => {
                if(item.id === action.itemObj.id) {
                    return {...action.itemObj};
                }
                return {...item};
            })
            return {
                ...state,
                itemList: newItemList
            }
        
        case DELETE_AUDIT_ITEM:
            const newAuditItemList = state.itemList.filter(item => 
                item.id !== action.itemId
            )
            return {
                ...state,
                itemList: newAuditItemList
            }

        default:
            return state;
    }
};

export default ComplianceAuditReducer;


// WEBPACK FOOTER //
// ./src/reducers/ComplianceAuditReducer.js